export default class GoogleMaps {
  private _gmbMapElements: Array<HTMLElement>;
  private _latLongElements: NodeListOf<Element>;

  public constructor() {
    this.initialize();
  }

  private initialize() {
    this._gmbMapElements = [];

    const dealeronMapElements = document.getElementsByTagName("dealeron-map");
    this._latLongElements = document.querySelectorAll(
      `[data-google-map-element="latLong"]`
    );

    if (dealeronMapElements?.length > 0) {
      this.initGmbMaps(dealeronMapElements);
    }

    if (this._latLongElements?.length > 0) {
      this.initLatLongMaps();
    }
  }

  private initGmbMaps(dealeronMapElements: HTMLCollectionOf<Element>) {
    for (let i = 0; i < dealeronMapElements.length; i++) {
      const mapElement = dealeronMapElements[i] as HTMLElement;
      this._gmbMapElements.push(mapElement);
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
          try {
            const { default: GoogleMyBusinessMaps } = await import(
              /* webpackChunkName: "googleMyBusinessMaps" */ "./googleMyBusinessMaps"
            );
            const gmbMap = new GoogleMyBusinessMaps(
              entry.target as HTMLElement
            );
            observer.unobserve(entry.target);
          } catch (error) {
            console.error(
              `GoogleMyBusinessMaps file path ./googleMyBusinessMaps not found.`
            );
            return;
          }
        }
      });
    });

    this._gmbMapElements.forEach((gmbMapElement) => {
      observer.observe(gmbMapElement);
    });
  }

  private initLatLongMaps() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
          try {
            const { default: GoogleLatLongMaps } = await import(
              /* webpackChunkName: "googleLatLongMaps" */ "./googleLatLongMaps"
            );
            const latlongMap = new GoogleLatLongMaps(
              entry.target as HTMLElement
            );
            observer.unobserve(entry.target);
          } catch (error) {
            console.error(
              `GoogleLatLongMaps file path ./googleLatLongMaps not found.`
            );
            return;
          }
        }
      });
    });

    this._latLongElements.forEach((latLongElement) => {
      observer.observe(latLongElement);
    });
  }
}
